class SearchHeader extends HTMLElement {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.fakeInput = document.querySelector('.search-header__input-placeholder');
    this.setupEventListeners();
    this.searchHeader = document.querySelector('.search-header-container');
    this.header = document.querySelector('header');
    this.topnav = document.querySelector('.TopNav');
    this.searchHeader.style.setProperty('--search-header-top', `${this.header.offsetHeight + this.topnav.offsetHeight - 1}px`);
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
    this.fakeInput.innerHTML = value;
  }
}

customElements.define('search-header', SearchHeader);
